import Axios, { fetcher, postFetcher } from 'util/Api';

export const getS2eReport = async ({ period_before, period_after, money_type, payment_type_ids } = {}) =>
  fetcher('/api/v1/hkd-books/s2e/', {
    params: {
      ...(period_before ? { period_before } : {}),
      ...(period_after ? { period_after } : {}),
      ...(money_type ? { money_type } : {}),
      ...(payment_type_ids && payment_type_ids.length ? { payment_type_ids: payment_type_ids.join(',') } : {}),
    },
  });

export const getS2dReport = async ({ period_before, period_after, product, warehouse, product_group, per_page } = {}) =>
  fetcher('/api/v1/hkd-books/s2d/', {
    params: {
      ...(period_before ? { period_before } : {}),
      ...(period_after ? { period_after } : {}),
      ...(product ? { product } : {}),
      ...(warehouse ? { warehouse } : {}),
      ...(product_group ? { product_group } : {}),
      ...(per_page ? { per_page } : {}),
      include_balance: 'true',
    },
  });

export const getS2aReport = async ({ period_before, period_after } = {}) =>
  fetcher('/api/v1/hkd-books/s2a/', {
    params: {
      ...(period_before ? { period_before } : {}),
      ...(period_after ? { period_after } : {}),
    },
  });

export const getS2bReport = async ({ period_before, period_after } = {}) =>
  fetcher('/api/v1/hkd-books/s2b/', {
    params: {
      ...(period_before ? { period_before } : {}),
      ...(period_after ? { period_after } : {}),
    },
  });

export const getS2cReport = async ({ period_before, period_after } = {}) =>
  fetcher('/api/v1/hkd-books/s2c/', {
    params: {
      ...(period_before ? { period_before } : {}),
      ...(period_after ? { period_after } : {}),
    },
  });

export const downloadStocktakeDeclaration = async ({ as_of, format = 'pdf' } = {}) =>
  Axios.get('/api/v1/hkd-books/stocktake-declaration/', {
    params: { as_of, format },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const downloadRevenueNotification = async ({ year, format = 'pdf' } = {}) =>
  Axios.get('/api/v1/hkd-books/filing-forms/01-tkn-cnkd/', {
    params: { year, format },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const downloadCnkdReturn = async ({ year, period, format = 'pdf' } = {}) =>
  Axios.get('/api/v1/hkd-books/filing-forms/01-cnkd/', {
    params: { year, period, format },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const downloadPitFinalization = async ({ year, format = 'pdf' } = {}) =>
  Axios.get('/api/v1/hkd-books/filing-forms/02-cnkd-tncn-qtt/', {
    params: { year, format },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const downloadBkStk = async ({ format = 'pdf' } = {}) =>
  Axios.get('/api/v1/hkd-books/filing-forms/01-bk-stk/', {
    params: { format },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const downloadTbDdkd = async ({ location_id, notice_type, format = 'pdf' } = {}) =>
  Axios.get('/api/v1/hkd-books/filing-forms/01-tb-ddkd/', {
    params: {
      ...(location_id != null ? { location_id } : {}),
      ...(notice_type ? { notice_type } : {}),
      format,
    },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const exportLedgerBook = async ({ book_code, period_from, period_to, format = 'xlsx' } = {}) =>
  Axios.get(`/api/v1/hkd-books/${book_code}/export/`, {
    params: { period_from, period_to, format },
    responseType: 'arraybuffer',
  }).then(res => res.data);

export const getTaxAlerts = async () => fetcher('/api/v1/hkd-books/tax-alerts');

export const dismissTaxAlert = async id => postFetcher(`/api/v1/hkd-books/tax-alerts/${id}/dismiss`);

export const markFilingSent = async ({ period_from, period_to, frequency, due_date }) =>
  postFetcher('/api/v1/hkd-books/filing-periods/mark-sent', { period_from, period_to, frequency, due_date });

export const undoFilingSent = async ({ period_from, period_to }) =>
  postFetcher('/api/v1/hkd-books/filing-periods/undo', { period_from, period_to });

export const HkdBooksAPI = {
  getS2eReport,
  getS2dReport,
  getS2aReport,
  getS2bReport,
  getS2cReport,
  downloadStocktakeDeclaration,
  downloadRevenueNotification,
  downloadCnkdReturn,
  downloadPitFinalization,
  downloadBkStk,
  downloadTbDdkd,
  exportLedgerBook,
  getTaxAlerts,
  dismissTaxAlert,
  markFilingSent,
  undoFilingSent,
};
